<div class="approver-picker-container">
  <div class="approver-input-wrapper">
    <div *ngIf="selectedApprover" class="selected-approver">
      <div class="approver-photo">
        <img *ngIf="hasPhoto(selectedApprover)" 
             [src]="getPhotoUrl(selectedApprover)" 
             alt="{{ selectedApprover.display_name }}"
             class="photo" />
        <div *ngIf="!hasPhoto(selectedApprover)" class="photo-placeholder">
          {{ getInitial(selectedApprover) }}
        </div>
      </div>
      <div class="approver-info">
        <div class="approver-name">{{ selectedApprover.display_name }}</div>
        <div class="approver-email">{{ selectedApprover.email }}</div>
      </div>
      <button type="button" class="clear-btn" (click)="clearApprover()" title="Clear selection">
        ✕
      </button>
    </div>

    <div *ngIf="!selectedApprover" class="search-wrapper">
      <input
        type="text"
        class="approver-search-input"
        placeholder="Search for approver by name or email…"
        [(ngModel)]="query"
        (ngModelChange)="onInputChange($event)"
        (focus)="showDropdown = query.trim().length > 0"
        (blur)="closeDropdown()"
        autocomplete="off" />
      <div *ngIf="searching" class="search-spinner">⏳</div>
    </div>
  </div>

  <!-- Search results dropdown -->
  <div *ngIf="showDropdown && (candidates.length > 0 || searching)" class="approver-dropdown">
    <div *ngIf="searching" class="loading-text">Searching…</div>

    <div class="approver-list">
      <div *ngFor="let person of visibleCandidates" 
           class="approver-item" 
           (mousedown)="$event.preventDefault()"
           (click)="selectApprover(person)">
        <div class="approver-photo-small">
          <img *ngIf="hasPhoto(person)" 
               [src]="getPhotoUrl(person)" 
               alt="{{ person.display_name }}"
               class="photo" />
          <div *ngIf="!hasPhoto(person)" class="photo-placeholder-small">
            {{ getInitial(person) }}
          </div>
        </div>
        <div class="approver-item-info">
          <div class="approver-item-name">{{ person.display_name }}</div>
          <div class="approver-item-email">{{ person.email }}</div>
          <div class="approver-item-title" *ngIf="person.job_title">
            {{ person.job_title }}
          </div>
        </div>
      </div>
    </div>

    <button *ngIf="remainingCount > 0" 
            type="button"
            class="show-more-btn"
            (mousedown)="$event.preventDefault()"
            (click)="showMore()">
      Show {{ remainingCount }} more…
    </button>
  </div>
</div>
